import { Component } from '@angular/core';

@Component({
  selector: 'politica',
  templateUrl: 'politica.html'
})
export class PoliticaPage {
	constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/politica/politica.ts